import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { MatSlider, MatSliderThumb } from '@angular/material/slider';

import { debounceTime, Subscription } from 'rxjs';

@Component({
    selector: 'app-duration-container',
    templateUrl: './duration-container.component.html',
    styleUrl: './duration-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatSlider, MatSliderThumb, ReactiveFormsModule]
})
export class DurationContainerComponent implements OnInit, OnDestroy {
  @Input({ required: true }) public duration: number;

  @Output() durationChange = new EventEmitter();
  public durationCtrl: FormControl<number> = new FormControl(null, [
    Validators.required,
    Validators.min(1),
    Validators.max(50),
  ]);

  public popularDurations: { label: string; value: number }[] = [
    { label: '7 days', value: 7 },
    { label: '10 days', value: 10 },
    { label: '12 days', value: 12 },
    { label: '15 days', value: 15 },
  ];

  #subs: Subscription;

  ngOnInit(): void {
    this.durationCtrl.setValue(this.duration);
    this.#subs = this.durationCtrl.valueChanges
      .pipe(debounceTime(400))
      .subscribe((res) => this.durationChange.emit(res));
  }

  ngOnDestroy(): void {
    this.#subs.unsubscribe();
  }
}
